module.exports = __webpack_public_path__ + "static/media/login_sync_title.f0460289.svg";